import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dialog-box"
}
const _hoisted_2 = { class: "dialog-action" }
const _hoisted_3 = { class: "dialog-error-message" }
const _hoisted_4 = { class: "dialog-button-area" }
const _hoisted_5 = {
  key: 0,
  class: "l-modal"
}

import liff from "@line/liff";
import { ref } from "vue";
import CommonButton from "./CommonButton.vue";
import { ProjectStore } from "../store/ProjectStore";

const error = "内容を入力してください。";
export type Props = {
  modelValue: boolean;
  projectId?: number;
};

// dialogの参照を保持する変数

export default /*@__PURE__*/_defineComponent({
  __name: 'ContactDialog',
  props: {
    modelValue: { type: Boolean },
    projectId: {}
  },
  emits: ["applyProject", "update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const contactDetail = ref("");
const isError = ref(false);
const projectStore = ProjectStore();

// APIを公開
__expose({
  openContactDialog,
  closeContactDialog,
});

const dialog = ref<HTMLDialogElement | null>(null);
// const open = ref(false);
const emit = __emit;
const props = __props;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const click = ($event: any) => {
  if (!$event || !$event.target) {
    isError.value = false;
    emit("update:modelValue", false);
    dialog?.value?.close();
  }
};

const sendMessage = async () => {
  // メッセージ送信する
  if (!contactDetail.value) {
    isError.value = true;
    return;
  } else {
    isError.value = false;
    dialog?.value?.close();
  }
    // 問い合わせ内容をAPIにも送信する
    await projectStore.messages({
      message: props.projectId
        ? `案件ID: ${props.projectId}\n\n----お問い合わせ内容----\n\n${contactDetail.value}\n`
        : `----お問い合わせ内容----\n\n${contactDetail.value}\n`,
    });
  if (liff.isInClient()) {
    liff
      .sendMessages([
        {
          type: "text",
          text: props.projectId
            ? `案件ID: ${props.projectId}\n\n----お問い合わせ内容----\n\n${contactDetail.value}\n`
            : `----お問い合わせ内容----\n\n${contactDetail.value}\n`,
        },
      ])
      .then(() => {
        // Lineメッセージ画面に戻る
        liff.closeWindow();
      });
  }
};

// 外部に公開するAPI。ダイアログを開いて、終了
function openContactDialog() {
  dialog?.value?.showModal();
}
function closeContactDialog() {
  dialog?.value?.close();
}

// ボタンが押されたときに呼ばれるコールバック
async function onDialogAction(action: boolean) {
  if (action) {
    sendMessage();
  } else {
    isError.value = false;
    dialog?.value?.close();
    emit("update:modelValue", false);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("dialog", {
      ref_key: "dialog",
      ref: dialog,
      class: "dialog",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (click($event))),
      style: _normalizeStyle([_ctx.modelValue ? 'z-index: 999;' : 'z-index: 0; visibility: hidden;'])
    }, [
      (_ctx.modelValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onDialogAction(false)))
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", null, _toDisplayString(_ctx.projectId ? `案件` : "") + "お問い合わせ", 1 /* TEXT */),
              _cache[4] || (_cache[4] = _createElementVNode("p", null, [
                _createTextVNode(" 入力頂いた内容はLINEのトークルーム投稿され、"),
                _createElementVNode("br"),
                _createTextVNode("事務局の方で順次確認させて頂きます。 ")
              ], -1 /* HOISTED */)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contactDetail).value = $event)),
                class: "dialog-text-area",
                required: "",
                placeholder: "お問い合わせ内容"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, contactDetail.value]
              ]),
              _withDirectives(_createElementVNode("h6", _hoisted_3, _toDisplayString(error), 512 /* NEED_PATCH */), [
                [_vShow, isError.value]
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(CommonButton, {
                  data: {
              status: contactDetail.value ? 0 : 2,
              button: `送信する`,
            },
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (contactDetail.value ? onDialogAction(true) : ''))
                }, null, 8 /* PROPS */, ["data"])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ], 4 /* STYLE */),
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.modelValue ? 'l-modal__bg' : ''])
          }, null, 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})